<div class="enter-email">
  <h3>Please enter the email address used on this order:</h3>
  <mat-form-field>
    <input
    matInput
    placeholder="Email"
    [(ngModel)]="email"
    (keyup.enter)="authorizeEmail()"
    />
  </mat-form-field>
  <div class="message-error warn-color">{{ message }}</div>
  <div class="pv-button" (click)="authorizeEmail()">Continue</div>
</div>
